import { createContext, useContext, useEffect, useState } from "react";
import { FILMS as FALLBACK } from "../data/films";

const FilmsContext = createContext({ films: FALLBACK, loading: true });

export const FilmsProvider = ({ children }) => {
  const [films, setFilms] = useState(FALLBACK);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/films`)
      .then((r) => r.json())
      .then((d) => {
        if (active && Array.isArray(d.films) && d.films.length) setFilms(d.films);
      })
      .catch(() => {})
      .finally(() => active && setLoading(false));
    return () => {
      active = false;
    };
  }, []);

  return (
    <FilmsContext.Provider value={{ films, loading }}>
      {children}
    </FilmsContext.Provider>
  );
};

export const useFilms = () => useContext(FilmsContext);
